"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.definedFirstSort = void 0;
const isValueDefined = (value) => {
    return (value !== undefined && value !== null && value !== "");
};
const definedFirstSort = (a, b, sort) => {
    if (!isValueDefined(a) && !isValueDefined(b)) {
        return 0;
    }
    else if (!isValueDefined(a))
        return 1;
    else if (!isValueDefined(b)) {
        return -1;
    }
    else {
        return sort(a, b);
    }
};
exports.definedFirstSort = definedFirstSort;
